<template>
    <div class="container ">
        <CommonBreadcrumb class="bread_block" />
        <div class="pdp_flex mt-4">
            <div class="pdp_flex_left">
                    <FreeProductFreeSlickSlider />
            </div>
            <div class="pdp_flex_right">
                <div>
                    <h5>Receive a Complimentary</h5>
                    <h1 class="my-3 font-active">14kt White Gold Lluvia Round Solitaire Necklace (1/2 Ct. Tw.)</h1>
                    <ul class="product_detail ps-0">
                        <li><span>Carat</span> <span>1/2</span></li>
                        <li><span>Clarity</span> <span>VS</span></li>
                        <!-- <li><span>Cut</span> <span>Excellent</span></li> -->
                        <li><span>Color</span><span>F-G</span></li>
                    </ul>
                </div>
            </div>
            
        </div>
        <div class="mt-5">
                <h3 class="mb-3 font-active">Terms & Conditions:</h3>
                <ul class="terms_condition ps-0">
                    <li>Every purchase made on the Friendly Diamonds’ website qualifies for this special offer.</li>
                    <li>This offer cannot be combined with any other ongoing promotions.</li>
                    <li>Your current purchase will not qualify for another free product if you have already received any other complimentary item on your previous orders.</li>
                    <li>One Solitaire Pendant is included per customer’s valuable feedback, regardless of the number of qualifying purchases during the offer period.</li>
                    <li>To qualify, the customer is required to submit the duly filled Share Your Moment form and their reviews on a minimum of 2 of our review platforms.</li>
                    <li>Ensure your submission comprises a minimum of 2 images or videos, with the purchased item from Friendly Diamonds prominently visible, and the purchaser or consumer actively engaged in at least one visual.</li>
                    <li>The total size of the uploaded images and videos cannot exceed 40MB.</li>
                    <li>Leave a review on at least two of the following platforms to qualify : <a href="https://www.trustpilot.com/review/friendlydiamonds.com" target="_blank" rel="nofollow noopener">Trustpilot, </a>
                        <a href="https://www.google.com/maps/place//data=!4m2!3m1!1s0x89c25943e5c1350d:0x3782b868a804629c?source=g.page.m._" target="_blank" rel="nofollow noopener">Google, </a>
                        <a href="https://www.bbb.org/us/ny/new-york/profile/jewelry-stores/friendly-diamonds-inc-0121-87151940/customer-reviews" target="_blank" rel="nofollow noopener">Better Business Bureau, </a>
                        <a href="https://www.yelp.com/biz/friendly-diamonds-new-york-4?osq=Friendly+Diamonds" target="_blank" rel="nofollow noopener">Yelp, </a>
                        <a href="http://www.theknot.com/review-wedding-vendors/2048281" target="_blank" rel="nofollow noopener">The Knot, </a>
                        <a href="http://www.weddingwire.com/shared/rate/new?vid=7aa045a974b6f846" target="_blank" rel="nofollow noopener">Wedding Wire. </a>
                     </li>
                    <li>The Solitaire Pendant is non-negotiable, non-refundable, and will not be replaced if lost, misplaced, or stolen.</li>
                    <li>Reporting and payment of all customs duties and taxes linked to its receipt are the exclusive responsibility of the purchaser.</li>
                    <li>Friendly Diamonds does not provide any warranty on the Solitaire Pendant, and reserves the right, at its sole discretion, to withhold the pendant in the event of any fraud or deception.</li>
                    <li>Offer valid while supplies last, and the offer terms are subject to change at any time without prior notice.</li>
                    <li>By participating in this offer, you agree to grant Friendly Diamonds the right to use any images or videos submitted for marketing purposes. Usage may include, but is not limited to, the website, social platforms, digital ads, newsletters, email marketing, blogs, and 3rd party blogs, as well as other suitable mediums.</li>
                    <li>Other restrictions may apply.</li>
                </ul>
        </div>
    </div>
</template>

<script setup>
useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>

<style scoped>
.main_block {
    padding-top: 4.6%;
}
h5 {
    font-size: 17px;
    color: #564a4a;
    font-weight: 600;
}
h1 {
    line-height: 1.2;
    font-size: 38px;
}
.product_detail li {
    list-style: none;
    font-size: 17px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3% 0;
    border-bottom: 1px solid #ccc;
}
ul.product_detail {
    width: 50%;
}
ul.product_detail li span {
    width: 50%;
    font-size: 16px;
    text-transform: capitalize;
    color: #6a6161;
}
h3 {
    font-size: 30px;
}

ul.terms_condition li {
    list-style: circle;
    font-size: 16px;
    line-height: 1.8;
    color: #6a6161;
    font-weight: 500;
}

ul.terms_condition li a {
    text-decoration: underline;
    color: #668b84;
}

ul.terms_condition {
    margin-left: 22px;
}

@media (max-width: 1100px){
    h1 {
        font-size: 26px;
        margin: 5% 0;
    }
    h5{
        font-size: 15px;
    }
    h3{
        font-size: 24px;
    }
}
@media (max-width: 1100px){
    ul.product_detail {
        width: 100%;
        margin: 0;
    }
    h5{
        margin-top: 30px;
    }
}
</style>